import type { MouseEventHandler, ReactElement } from 'react'
import React from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from 'react-router-dom'
import type { IconComponent } from '../Icon'
import { Icon } from '../Icon'
import * as S from './ButtonClean.styled'

type ButtonCleanProps = {
  ariaLabel?: string
  appearance?: 'primary' | 'secondary' | 'destructive' | 'success' | 'warning' | 'inherit'
  href?: string
  target?: '_blank'
  analyticsKey?: string
  to?: LinkProps['to']
  state?: LinkProps['state']
  label: ReactElement | string
  title?: string
  icon?: IconComponent
  withUnderline?: boolean
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const getComponent = ({ to, href }: Pick<ButtonCleanProps, 'to' | 'href'>) => {
  if (to) return Link

  if (href) return 'a'

  return 'button'
}

export const ButtonClean = ({
  appearance = 'primary',
  ariaLabel,
  analyticsKey,
  to,
  state,
  href,
  target,
  label,
  title,
  icon,
  withUnderline = true,
  disabled = false,
  type = 'button',
  onClick,
}: ButtonCleanProps) => (
  <S.Button
    $appearance={appearance}
    as={getComponent({ to, href })}
    to={to}
    state={state}
    href={href}
    target={target}
    title={title}
    $withUnderline={withUnderline}
    disabled={disabled}
    onClick={onClick}
    type={type}
    aria-label={ariaLabel}
    data-testid="ButtonClean"
    data-analytics={analyticsKey}
  >
    {icon && <Icon component={icon} height={12} ariaHidden />}
    {label}
  </S.Button>
)
